<div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2">
  <div class="prese_heading">
  <h2 class="m-0">{{ parentData.title }}</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </div>
  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Service name</mat-label>
        <input
          [maxlength]="30"
          [(ngModel)]="serviceListData.serviceName"
          matInput
          #input
        />
       
        
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          [(ngModel)]="serviceListData.description"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <!-- <div>

            
         
            <mat-checkbox value="home" (change)="change($event)" [checked]="isHome"></mat-checkbox>
            <mat-label>Home service</mat-label>
            
        
         
            <mat-checkbox value="shop" (change)="change($event)" [checked]="isShop"></mat-checkbox>
            <mat-label>Shop service</mat-label>
    </div> -->
    <div >
        <mat-form-field appearance="outline">
          <mat-label>Home rate</mat-label>
          <input 
          [(ngModel)]="serviceListData.home_rate"
          matInput
        
        />
          
        </mat-form-field>
    </div>
    <div >
        <mat-form-field appearance="outline">
          <mat-label>Shop rate</mat-label>
          <input 
          [(ngModel)]="serviceListData.shop_rate"
          matInput
        
        />
         
        </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Approx time(in minutes)</mat-label>
        <input 
          [(ngModel)]="serviceListData.approxTime"
          matInput

        />
       
      </mat-form-field>
    </div>
    <!-- <div>
        <mat-label>Discount applicable?</mat-label>
        <br>

        <input type="radio" id="yes" name="discountApplicable" value="applicable" [checked]="isDiscount == true" (click)="onApp($event)">
        <label for="yes">Yes</label>
        <input type="radio" id="no" name="discountApplicable" [checked]="isDiscount == false" value="not-applicable" (click)="onApp($event)">
        <label for="no">No</label>

    </div> -->
    <!-- <div *ngIf="serviceListData.discountStatus == '1'">
        <mat-label>Discount type</mat-label>
        <br>

        <input type="radio" id="percent" name="discountType" [checked]="isPercent == true" value="percent" (click)="discType($event)">
        <label for="percent">Percent</label>
        <input type="radio" id="amount" name="discountType" [checked]="isAmount == true" value="amount" (click)="discType($event)">
        <label for="amount">Amount</label>

    </div>
    <div *ngIf="serviceListData.discountStatus == '1'">
        <mat-form-field appearance="outline">
          <mat-label>Discount Amount</mat-label>
          <input 
            [(ngModel)]="serviceListData.discountAmount"
            matInput
  
          />
         
        </mat-form-field>
      </div> -->
    <!-- <input type="text" placeholder="Enter name" /> -->
    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
    <mat-chip-listbox
      style="display: flex; flex-wrap: wrap; width: 400px"
      aria-label="Fish selection"
      class="mb-2"
      *ngIf="!loader"
    >
      <mat-chip
        *ngIf="assetList.length > 0"
        color="primary"
        selected
        [removable]="removable"
        (removed)="removeAsset()"
        
        >{{ assetList[assetList.length - 1].assetName }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon></mat-chip
      >
    </mat-chip-listbox>
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          multiple
          (change)="onUploadImage($event)"
        />
      </div>
      <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !serviceListData.serviceName ||
        !serviceListData.description ||
        !serviceListData.approxTime 
      "
      (click)="onPost()"
    >
      {{ editMode ? "Edit" : "Save" }}
    </button>
  </mat-dialog-actions>
  